import * as actionType from "./constants";

const getStandardEntityParamsStateKey = entityType => {
    if (entityType === "client-standard-templates") return "clientStandardEntityParams";
    if (entityType === "uniformat-level-5-templates") return "UniformatLevel5EntityParams";
    return "UniformatEntityParams";
};

const initialState = {
    entityParams: {
        entity: null,
        selectedEntity: null,
        selectedRowId: null,
        paginationParams: {
            totalPages: 0,
            perPage: 100,
            currentPage: 0,
            totalCount: 0
        },
        params: {
            limit: 100,
            offset: 0,
            search: "",
            filters: null,
            filterKeys: null,
            list: null,
            order: null,
            asset_ids: [],
            image_or_not: null,
            me: null,
            last_synced_at: false
        },
        appliedFilterValue: {
            search: "",
            filters: null,
            filterKeys: null,
            list: null
        },
        wildCardFilterParams: {},
        filterParams: {},
        tableConfig: null,
        incompletedAssets: 0
    },
    surveyAssetEntityParams: {
        entity: null,
        selectedEntity: null,
        selectedRowId: null,
        paginationParams: {
            totalPages: 0,
            perPage: 40,
            currentPage: 0,
            totalCount: 0
        },
        params: {
            limit: 40,
            offset: 0,
            search: "",
            filters: null,
            filterKeys: null,
            list: null,
            order: null
        },
        wildCardFilterParams: {},
        filterParams: {},
        tableConfig: null,
        selectedAssetsId: []
    },
    inaccessibleSpaceEntityParams: {
        entity: null,
        selectedEntity: null,
        selectedRowId: null,
        paginationParams: {
            totalPages: 0,
            perPage: 100,
            currentPage: 0,
            totalCount: 0
        },
        params: {
            limit: 100,
            offset: 0,
            search: "",
            filters: null,
            filterKeys: null,
            list: null,
            order: null
        },
        wildCardFilterParams: {},
        filterParams: {},
        tableConfig: null
    },
    assetVoiceNotesEntityParams: {
        entity: null,
        selectedEntity: null,
        selectedRowId: null,
        paginationParams: {
            totalPages: 0,
            perPage: 100,
            currentPage: 0,
            totalCount: 0
        },
        params: {
            limit: 100,
            offset: 0,
            search: "",
            filters: null,
            filterKeys: null,
            list: null,
            order: null
        },
        wildCardFilterParams: {},
        filterParams: {},
        tableConfig: null
    },
    clientStandardEntityParams: {
        entity: null,
        selectedEntity: null,
        selectedRowId: null,
        paginationParams: {
            totalPages: 0,
            perPage: 100,
            currentPage: 0,
            totalCount: 0
        },
        params: {
            limit: 100,
            offset: 0,
            search: "",
            filters: null,
            filterKeys: null,
            list: null,
            order: null,
            listIds: null,
            fe_list_label: null,
            fe_wildcard_label: null,
            tab: null,
            selected_id: null
        },
        has_image: "",
        wildCardFilterParams: {},
        filterParams: {},
        tableConfig: null,
        projectId: null,
        selectedRows: null
    },
    clientDeliverableEntityParams: {
        entity: null,
        selectedEntity: null,
        selectedRowId: null,
        paginationParams: {
            totalPages: 0,
            perPage: 100,
            currentPage: 0,
            totalCount: 0
        },
        params: {
            limit: 100,
            offset: 0,
            search: "",
            filters: null,
            filterKeys: null,
            list: null,
            order: null,
            listIds: null,
            fe_list_label: null,
            fe_wildcard_label: null,
            tab: null
        },
        has_image: false,
        wildCardFilterParams: {},
        filterParams: {},
        tableConfig: null,
        projectId: null
    },
    UniformatEntityParams: {
        entity: null,
        selectedEntity: null,
        selectedRowId: null,
        paginationParams: {
            totalPages: 0,
            perPage: 100,
            currentPage: 0,
            totalCount: 0
        },
        params: {
            limit: 100,
            offset: 0,
            search: "",
            filters: null,
            filterKeys: null,
            list: null,
            order: null,
            listIds: null,
            fe_list_label: null,
            fe_wildcard_label: null,
            selected_id: null
        },
        has_image: false,
        wildCardFilterParams: {},
        filterParams: {},
        tableConfig: null,
        projectId: null,
        selectedRows: null
    },
    UniformatLevel5EntityParams: {
        entity: null,
        selectedEntity: null,
        selectedRowId: null,
        paginationParams: {
            totalPages: 0,
            perPage: 100,
            currentPage: 0,
            totalCount: 0
        },
        params: {
            limit: 100,
            offset: 0,
            search: "",
            filters: null,
            filterKeys: null,
            list: null,
            order: null,
            listIds: null,
            fe_list_label: null,
            fe_wildcard_label: null,
            selected_id: null
        },
        has_image: false,
        wildCardFilterParams: {},
        filterParams: {},
        tableConfig: null,
        projectId: null,
        selectedRows: null
    },
    dropDownList: {},
    dropDownCount: {},
    dropDownLoading: {},
    addAssetSurveyProjectResponse: null,
    addAssetSurveyProjectResponseLoading: false,
    assetSurveyProjectsList: { loading: false },
    surveyAssetList: { surveyAssetLoading: false },
    deleteAssetSurveyProjectResponse: null,
    getAssetSurveyProjectById: null,
    getAssetSurveyProjectByIdLoading: false,
    getSurveyAssetById: null,
    getSurveyAssetByIdLoading: false,
    updateAssetSurveyProjectResponse: null,
    updateAssetSurveyProjectResponseLoading: false,
    getListForCommonFilterResponse: {},
    getDataLogsResponse: { loading: false },
    restoreDataLogsResponse: { loading: false },
    updateSurveyAssetResponse: null,
    updateSurveyAssetResponseLoading: false,
    getSurveyAssetImagesById: null,
    getSurveyAssetImagesByIdLoading: false,
    getReviewedCount: null,
    getReviewedCountLoading: null,
    transferAssetsResponse: null,
    transferAssetsResponseLoading: null,
    getCompletedCount: null,
    getCompletedCountLoading: null,
    getSurveyAssetNoteById: null,
    getSurveyAssetNoteByIdLoading: false,
    inaccessibleSpaceList: { loading: false },
    getInaccessibleSpaceById: null,
    getInaccessibleSpaceByIdLoading: false,
    getReasonsById: null,
    getReasonsByIdLoading: false,
    addReasonResponse: null,
    addReasonResponseLoading: false,
    addDynamicFormResponse: null,
    addDynamicFormResponseLoading: false,
    updateInaccessibleSpaceSettingsResponse: null,
    updateInaccessibleSpaceSettingsResponseLoading: false,
    updateSurveyAssetFieldsResponse: null,
    updateSurveyAssetFieldsResponseLoading: false,
    updateAssetImageCommentResponse: null,
    updateAssetImageCommentResponseLoading: false,
    getSurveyAssetsExportResponse: null,
    getSurveyAssetsExportResponseLoading: false,
    getAssetSurveyProjectExportResponse: null,
    getAssetSurveyProjectExportResponseLoading: false,
    getSurveyAssetsCommonData: null,
    getSurveyAssetsCommonDataLoading: false,
    updateMultiSurveyAsset: null,
    updateMultiSurveyAssetLoading: false,
    getAllSurveyAssetIdsResponse: null,
    getAllSurveyAssetIdsResponseLoading: false,
    getListForSurveyAssetsCommonFilterResponse: null,
    getSurveyorDropdownResponse: null,
    getSurveyorDropdownResponseLoading: false,
    getAssetVoiceNotesResponse: null,
    getAssetVoiceNotesResponseLoading: false,
    deleteAssetByIdVoiceNotesResponse: null,
    deleteAssetByIdVoiceNotesLoading: false,
    getSurveyRecommendationsImagesById: null,
    getSurveyRecommendationsImagesByIdLoading: false,
    masterFilterList: {},
    appliedFilterNames: {},
    currentAudio: null,
    isGlobalLoading: null,
    uniformatList: {},
    updateSurveyAssetImageResponse: null,
    updateSurveyAssetImageResponseLoading: false,
    assetSurveyProjectMasterFilterList: {},
    getDynamicDropdownDataResponse: {},
    getDynamicDropdownDataResponseLoading: {},
    defaultImageLoading: false,
    defaultImageResponse: null,
    deleteImageResponse: null,
    deleteImageLoading: false,
    runWellsFargoResponse: null,
    runWellsFargoResponseLoading: false,
    searchAndReplaceAssetResponse: null,
    searchAndReplaceAssetLoading: false,
    findAssetBeforeReplacingAssetResponse: null,
    findAssetBeforeReplacingAssetLoading: false,
    revertAssetResponse: null,
    revertAssetResponseLoading: false,
    clientStandardList: { loading: false },
    standardSyncedData: { loading: false },
    updateStandardData: { loading: false },
    updateClientDeliverableLoading: false,
    clientDeliverableList: { loading: false },
    uniformatLevelList: { loading: false },
    dropdownFilterList: {},
    dropDownFilterLoading: { loading: false },
    getStandardById: { loading: false },
    clientDeliverableFilterList: {},
    getStandardImagesById: {},
    getAiAnalyseResponse: {},
    postAiAnalyseResponse: {},
    clearAiAnalyseResponse: {},
    patchAiAnalyseResponse: { loading: false },
    assetTableAiAnalysisClick: false,
    getselectAllStandardList: {},
    getStandardExportResponse: { loading: false },
    getUniformatExportResponse: { loading: false },
    clearAiAnalyseResponse: {},
    getListForSurveyor: {},
    getGroupUpdateRespose: {},
    patchAiAnalyseAssetResponse: { loading: false },
    getAiAnalyseKeys: {},
    getEntityDropdownResponse: { loading: false },
    getGroupEditProgressResponse: { loading: false },
    revertMobileAssetByIdResponse: null
};

const reducers = (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_ASSET_SURVEY_PROJECTS_REQUEST:
            return {
                ...state,
                assetSurveyProjectsList: { loading: true }
            };
        case actionType.GET_ASSET_SURVEY_PROJECTS_SUCCESS:
            return {
                ...state,
                assetSurveyProjectsList: { loading: false, success: true, ...action.response }
            };
        case actionType.GET_ASSET_SURVEY_PROJECTS_FAILURE:
            return {
                ...state,
                assetSurveyProjectsList: { loading: false, success: false, ...action.error }
            };

        case actionType.GET_SURVEY_ASSET_REQUEST:
            return {
                ...state,
                surveyAssetList: { surveyAssetLoading: true }
            };
        case actionType.GET_SURVEY_ASSET_SUCCESS:
            return {
                ...state,
                surveyAssetList: { surveyAssetLoading: false, success: true, ...action.response }
            };
        case actionType.GET_SURVEY_ASSET_FAILURE:
            return {
                ...state,
                surveyAssetList: { surveyAssetLoading: false, success: false, ...action.error }
            };

        case actionType.GET_ASSET_SURVEY_PROJECT_DROPDOWN_REQUEST:
            return {
                ...state,
                dropDownList: {
                    ...state.dropDownList,
                    [action.entity]: []
                },
                dropDownCount: {
                    ...state.dropDownCount,
                    [action.entity]: []
                },
                dropDownLoading: { ...state.dropDownLoading, [action.entity]: true }
            };
        case actionType.GET_ASSET_SURVEY_PROJECT_DROPDOWN_SUCCESS:
            return {
                ...state,
                dropDownLoading: { ...state.dropDownLoading, [action.entity]: false },
                dropDownList: {
                    ...state.dropDownList,
                    [action.entity]: action.response[action.entity]
                },
                dropDownCount: {
                    ...state.dropDownCount,
                    [action.entity]: action.response?.count ?? action.response[action.entity]?.length
                }
            };
        case actionType.GET_ASSET_SURVEY_PROJECT_DROPDOWN_FAILURE:
            return {
                ...state,
                dropDownLoading: { ...state.dropDownLoading, [action.entity]: false },
                dropDownList: {
                    ...state.dropDownList
                },
                dropDownCount: {
                    ...state.dropDownCount
                }
            };

        case actionType.ADD_ASSET_SURVEY_PROJECT_DATA_REQUEST:
            return {
                ...state,
                addAssetSurveyProjectResponse: null,
                addAssetSurveyProjectResponseLoading: true
            };
        case actionType.ADD_ASSET_SURVEY_PROJECT_DATA_SUCCESS:
            return {
                ...state,
                addAssetSurveyProjectResponse: action.response,
                addAssetSurveyProjectResponseLoading: false
            };
        case actionType.ADD_ASSET_SURVEY_PROJECT_DATA_FAILURE:
            return {
                ...state,
                addAssetSurveyProjectResponse: action.error,
                addAssetSurveyProjectResponseLoading: false
            };

        case actionType.UPDATE_ASSET_SURVEY_PROJECT_DATA_REQUEST:
            return {
                ...state,
                updateAssetSurveyProjectResponse: null,
                updateAssetSurveyProjectResponseLoading: true
            };
        case actionType.UPDATE_ASSET_SURVEY_PROJECT_DATA_SUCCESS:
            return {
                ...state,
                updateAssetSurveyProjectResponse: action.response,
                updateAssetSurveyProjectResponseLoading: false
            };
        case actionType.UPDATE_ASSET_SURVEY_PROJECT_DATA_FAILURE:
            return {
                ...state,
                updateAssetSurveyProjectResponse: action.error,
                updateAssetSurveyProjectResponseLoading: false
            };

        case actionType.UPDATE_SURVEY_ASSET_DATA_REQUEST:
            return {
                ...state,
                updateSurveyAssetResponse: null,
                updateSurveyAssetResponseLoading: action.response
            };
        case actionType.UPDATE_SURVEY_ASSET_DATA_SUCCESS:
            return {
                ...state,
                updateSurveyAssetResponse: action.response,
                updateSurveyAssetResponseLoading: false
            };
        case actionType.UPDATE_SURVEY_ASSET_DATA_FAILURE:
            return {
                ...state,
                updateSurveyAssetResponse: action.error,
                updateSurveyAssetResponseLoading: false
            };

        case actionType.UPDATE_ASSET_SURVEY_PROJECTS_ENTITY_PARAMS_SUCCESS:
            return {
                ...state,
                entityParams: { ...action.response }
            };
        case actionType.UPDATE_ASSET_SURVEY_PROJECTS_ENTITY_PARAMS_FAILURE:
            return {
                ...state,
                entityParams: { ...action.error }
            };

        case actionType.DELETE_ASSET_SURVEY_PROJECT_REQUEST:
            return {
                ...state
            };
        case actionType.DELETE_ASSET_SURVEY_PROJECT_SUCCESS:
            return {
                ...state,
                deleteAssetSurveyProjectResponse: { success: true, ...action.response }
            };
        case actionType.DELETE_ASSET_SURVEY_PROJECT_FAILURE:
            return {
                ...state,
                deleteAssetSurveyProjectResponse: { success: false, ...action.error }
            };

        case actionType.GET_ASSET_SURVEY_PROJECT_BY_ID_REQUEST:
            return {
                ...state,
                getAssetSurveyProjectByIdLoading: true
            };
        case actionType.GET_ASSET_SURVEY_PROJECT_BY_ID_SUCCESS:
            return {
                ...state,
                getAssetSurveyProjectById: { success: true, data: { ...action.response }, id: action?.id },
                getAssetSurveyProjectByIdLoading: false
            };
        case actionType.GET_ASSET_SURVEY_PROJECT_BY_ID_FAILURE:
            return {
                ...state,
                getAssetSurveyProjectById: { success: false, ...action.error },
                getAssetSurveyProjectByIdLoading: false
            };

        case actionType.GET_SURVEY_ASSET_IMAGES_BY_ID_REQUEST:
            return {
                ...state,
                getSurveyAssetImagesByIdLoading: true
            };
        case actionType.GET_SURVEY_ASSET_IMAGES_BY_ID_SUCCESS:
            return {
                ...state,
                getSurveyAssetImagesById: { success: true, data: { ...action.response } },
                getSurveyAssetImagesByIdLoading: false
            };
        case actionType.GET_SURVEY_ASSET_IMAGES_BY_ID_FAILURE:
            return {
                ...state,
                getSurveyAssetImagesById: { success: false, ...action.error },
                getSurveyAssetImagesByIdLoading: false
            };

        case actionType.GET_ASSET_SIGNATURE_REQUEST:
            return {
                ...state,
                getAssetSignatureLoading: true
            };
        case actionType.GET_ASSET_SIGNATURE_SUCCESS:
            return {
                ...state,
                getAssetSignature: { success: true, data: action.response?.data ?? null },
                getAssetSignatureLoading: false
            };
        case actionType.GET_ASSET_SIGNATURE_FAILURE:
            return {
                ...state,
                getAssetSignature: { success: false, data: null, ...action.error },
                getAssetSignatureLoading: false
            };
        case actionType.RESET_ASSET_SIGNATURE:
            return {
                ...state,
                getAssetSignature: null,
                getAssetSignatureLoading: false
            };

        case actionType.GET_SURVEY_RECOMMENDATION_IMAGES_BY_ID_REQUEST:
            return {
                ...state,
                getSurveyRecommendationsImagesByIdLoading: true
            };
        case actionType.GET_SURVEY_RECOMMENDATION_IMAGES_BY_ID_SUCCESS:
            return {
                ...state,
                getSurveyRecommendationsImagesById: { success: true, data: { ...action.response } },
                getSurveyRecommendationsImagesByIdLoading: false
            };
        case actionType.GET_SURVEY_RECOMMENDATION_IMAGES_BY_ID_FAILURE:
            return {
                ...state,
                getSurveyRecommendationsImagesById: { success: false, ...action.error },
                getSurveyRecommendationsImagesByIdLoading: false
            };

        case actionType.GET_SURVEY_ASSET_BY_ID_REQUEST:
            return {
                ...state,
                getSurveyAssetByIdLoading: true
            };
        case actionType.GET_SURVEY_ASSET_BY_ID_SUCCESS:
            return {
                ...state,
                getSurveyAssetById: { success: true, data: { ...action.response } },
                getSurveyAssetByIdLoading: false
            };
        case actionType.GET_SURVEY_ASSET_BY_ID_FAILURE:
            return {
                ...state,
                getSurveyAssetById: { success: false, ...action.error },
                getSurveyAssetByIdLoading: false
            };

        case actionType.GET_COMMON_FILTER_LIST_FOR_ASSET_SURVEY_PROJECT_REQUEST:
            return {
                ...state
            };
        case actionType.GET_COMMON_FILTER_LIST_FOR_ASSET_SURVEY_PROJECT_SUCCESS:
            return {
                ...state,
                getListForCommonFilterResponse: { success: true, list: action.response || [] }
            };
        case actionType.GET_COMMON_FILTER_LIST_FOR_ASSET_SURVEY_PROJECT_FAILURE:
            return {
                ...state,
                getListForCommonFilterResponse: { success: false, ...action.error }
            };

        case actionType.GET_COMMON_FILTER_LIST_FOR_SURVEY_ASSETS_REQUEST:
            return {
                ...state
            };
        case actionType.GET_COMMON_FILTER_LIST_FOR_SURVEY_ASSETS_SUCCESS:
            return {
                ...state,
                getListForSurveyAssetsCommonFilterResponse: { success: true, list: action.response?.list, count: action.response.count || [] }
            };
        case actionType.GET_COMMON_FILTER_LIST_FOR_SURVEY_ASSETS_FAILURE:
            return {
                ...state,
                getListForSurveyAssetsCommonFilterResponse: { success: false, ...action.error }
            };

        case actionType.RESET_REDUCER:
            return {
                ...state,
                ...(action?.entity === "standards"
                    ? {
                          standardSyncedData: { loading: false },
                          clientStandardList: { loading: false },
                          clientDeliverableList: { loading: false },
                          uniformatLevelList: { ...(state.uniformatLevelList?.loading ? { loading: true } : { loading: false }) },
                          updateStandardData: { loading: false }
                      }
                    : {
                          ...(action?.entity === "image" ? {} : { getAssetSurveyProjectById: null }),
                          dropDownList: {},
                          dropDownCount: {},
                          getSurveyAssetImagesById: null,
                          getSurveyAssetNoteById: null,
                          getSurveyRecommendationsImagesById: null,
                          getSurveyRecommendationsImagesByIdLoading: false,
                          standardSyncedData: { loading: false },
                          clientStandardList: { loading: false },
                          clientDeliverableList: { loading: false },
                          uniformatLevelList: { loading: false },
                          updateStandardData: { loading: false }
                      })
            };

        case actionType.RESET_FORM:
            return { ...state, getSurveyAssetById: null };
        case actionType.GET_ALL_DATA_LOG_REQUEST:
            return {
                ...state,
                getDataLogsResponse: { loading: true }
            };
        case actionType.GET_ALL_DATA_LOG_SUCCESS:
            return {
                ...state,
                getDataLogsResponse: { loading: false, success: true, ...action.response }
            };
        case actionType.GET_ALL_DATA_LOG_FAILURE:
            return {
                ...state,
                getDataLogsResponse: { loading: false, success: false, ...action.error }
            };
        case actionType.RESTORE_DATA_LOG_REQUEST:
            return {
                ...state,
                restoreDataLogsResponse: { loading: true }
            };
        case actionType.RESTORE_DATA_LOG_SUCCESS:
            return {
                ...state,
                restoreDataLogsResponse: { loading: false, success: true, ...action.response }
            };
        case actionType.RESTORE_DATA_LOG_FAILURE:
            return {
                ...state,
                restoreDataLogsResponse: { loading: false, success: false, ...action.error }
            };

        case actionType.GET_REVIEWED_ASSETS_COUNT_REQUEST:
            return {
                ...state,
                getReviewedCount: null,
                getReviewedCountLoading: true
            };
        case actionType.GET_REVIEWED_ASSETS_COUNT_SUCCESS:
            return {
                ...state,
                getReviewedCount: { success: true, ...action.response },
                getReviewedCountLoading: false
            };
        case actionType.GET_REVIEWED_ASSETS_COUNT_FAILURE:
            return {
                ...state,
                getReviewedCount: { success: false, ...action.error },
                getReviewedCountLoading: false
            };

        case actionType.TRANSFER_REVIEWED_ASSETS_REQUEST:
            return {
                ...state,
                transferAssetsResponse: null,
                transferAssetsResponseLoading: true
            };
        case actionType.TRANSFER_REVIEWED_ASSETS_SUCCESS:
            return {
                ...state,
                transferAssetsResponse: { success: true, ...action.response },
                transferAssetsResponseLoading: false,
                surveyAssetEntityParams: {
                    ...state?.surveyAssetEntityParams,
                    selectedAssetsId: (state?.surveyAssetEntityParams?.selectedAssetsId ?? [])?.filter(e => e !== action?.assetId)
                }
            };
        case actionType.TRANSFER_REVIEWED_ASSETS_FAILURE:
            return {
                ...state,
                transferAssetsResponse: { success: false, ...action.error },
                transferAssetsResponseLoading: false
            };
        case actionType.REVERT_MOBILE_ASSET_REQUEST:
            return {
                ...state,
                revertAssetResponse: null,
                revertAssetResponseLoading: true
            };
        case actionType.REVERT_MOBILE_ASSET_SUCCESS:
            return {
                ...state,
                revertAssetResponse: { success: true, ...action.response },
                revertAssetResponseLoading: false
            };
        case actionType.REVERT_MOBILE_ASSET_FAILURE:
            return {
                ...state,
                revertAssetResponse: { success: false, ...action.error },
                revertAssetResponseLoading: false
            };

        case actionType.GET_COMPLETED_ASSETS_COUNT_REQUEST:
            return {
                ...state,
                getCompletedCount: null,
                getCompletedCountLoading: true
            };
        case actionType.GET_COMPLETED_ASSETS_COUNT_SUCCESS:
            return {
                ...state,
                getCompletedCount: { success: true, ...action.response },
                getCompletedCountLoading: false
            };
        case actionType.GET_COMPLETED_ASSETS_COUNT_FAILURE:
            return {
                ...state,
                getCompletedCount: { success: false, ...action.error },
                getCompletedCountLoading: false
            };
        case actionType.GET_INACCESSIBLE_SPACE_REQUEST:
            return {
                ...state,
                inaccessibleSpaceList: { loading: true }
            };
        case actionType.GET_INACCESSIBLE_SPACE_SUCCESS:
            return {
                ...state,
                inaccessibleSpaceList: { loading: false, success: true, ...action.response }
            };
        case actionType.GET_INACCESSIBLE_SPACE_FAILURE:
            return {
                ...state,
                inaccessibleSpaceList: { loading: false, success: false, ...action.error }
            };

        case actionType.GET_INACCESSIBLE_SPACE_BY_ID_REQUEST:
            return {
                ...state,
                getInaccessibleSpaceByIdLoading: true
            };
        case actionType.GET_INACCESSIBLE_SPACE_BY_ID_SUCCESS:
            return {
                ...state,
                getInaccessibleSpaceById: { success: true, data: { ...action.response } },
                getInaccessibleSpaceByIdLoading: false
            };
        case actionType.GET_INACCESSIBLE_SPACE_BY_ID_FAILURE:
            return {
                ...state,
                getInaccessibleSpaceById: { success: false, ...action.error },
                getInaccessibleSpaceByIdLoading: false
            };
        case actionType.GET_SURVEY_ASSET_NOTE_BY_ID_REQUEST:
            return {
                ...state,
                getSurveyAssetNoteByIdLoading: true
            };
        case actionType.GET_SURVEY_ASSET_NOTE_BY_ID_SUCCESS:
            return {
                ...state,
                getSurveyAssetNoteById: { success: true, data: { ...action.response } },
                getSurveyAssetNoteByIdLoading: false
            };
        case actionType.GET_SURVEY_ASSET_NOTE_BY_ID_FAILURE:
            return {
                ...state,
                getSurveyAssetNoteById: { success: false, ...action.error },
                getSurveyAssetNoteByIdLoading: false
            };

        case actionType.GET_REASONS_BY_ID_REQUEST:
            return {
                ...state,
                getReasonsByIdLoading: true
            };
        case actionType.GET_REASONS_BY_ID_SUCCESS:
            return {
                ...state,
                getReasonsById: { success: true, data: { ...action.response } },
                getReasonsByIdLoading: false
            };
        case actionType.GET_REASONS_BY_ID_FAILURE:
            return {
                ...state,
                getReasonsById: { success: false, ...action.error },
                getReasonsByIdLoading: false
            };

        case actionType.ADD_REASON_REQUEST:
            return {
                ...state,
                addReasonResponseLoading: true
            };
        case actionType.ADD_REASON_SUCCESS:
            return {
                ...state,
                addReasonResponse: { success: true, data: { ...action.response } },
                addReasonResponseLoading: false
            };
        case actionType.ADD_REASON_FAILURE:
            return {
                ...state,
                addReasonResponse: { success: false, ...action.error },
                addReasonResponseLoading: false
            };

        case actionType.ADD_DYNAMIC_FORM_SUBMIT_REQUEST:
            return {
                ...state,
                addDynamicFormResponseLoading: true
            };
        case actionType.ADD_DYNAMIC_FORM_SUBMIT_SUCCESS:
            return {
                ...state,
                addDynamicFormResponse: { success: true, data: { ...action.response } },
                addDynamicFormResponseLoading: false
            };
        case actionType.ADD_DYNAMIC_FORM_SUBMIT_FAILURE:
            return {
                ...state,
                addDynamicFormResponse: { success: false, ...action.error },
                addDynamicFormResponseLoading: false
            };

        case actionType.UPDATE_INACCESSIBLE_SPACE_SETTINGS_REQUEST:
            return {
                ...state,
                updateInaccessibleSpaceSettingsResponseLoading: true
            };
        case actionType.UPDATE_INACCESSIBLE_SPACE_SETTINGS_SUCCESS:
            return {
                ...state,
                updateInaccessibleSpaceSettingsResponse: { success: true, data: { ...action.response } },
                updateInaccessibleSpaceSettingsResponseLoading: false
            };
        case actionType.UPDATE_INACCESSIBLE_SPACE_SETTINGS_FAILURE:
            return {
                ...state,
                updateInaccessibleSpaceSettingsResponse: { success: false, ...action.error },
                updateInaccessibleSpaceSettingsResponseLoading: false
            };

        case actionType.UPDATE_SURVEY_ASSET_FIELDS_REQUEST:
            return {
                ...state,
                updateSurveyAssetFieldsResponseLoading: true
            };
        case actionType.UPDATE_SURVEY_ASSET_FIELDS_SUCCESS:
            return {
                ...state,
                updateSurveyAssetFieldsResponse: { success: true, data: { ...action.response } },
                updateSurveyAssetFieldsResponseLoading: false
            };
        case actionType.UPDATE_SURVEY_ASSET_FIELDS_FAILURE:
            return {
                ...state,
                updateSurveyAssetFieldsResponse: { success: false, ...action.error },
                updateSurveyAssetFieldsResponseLoading: false
            };

        case actionType.UPDATE_SURVEY_ASSET_IMAGE_GLOBAL_REQUEST:
            return {
                ...state,
                updateSurveyAssetImageResponseLoading: true
            };
        case actionType.UPDATE_SURVEY_ASSET_IMAGE_GLOBAL_SUCCESS:
            return {
                ...state,
                updateSurveyAssetImageResponse: { success: true, data: { ...action.response } },
                updateSurveyAssetImageResponseLoading: false
            };
        case actionType.UPDATE_SURVEY_ASSET_IMAGE_GLOBAL_FAILURE:
            return {
                ...state,
                updateSurveyAssetImageResponse: { success: false, ...action.error },
                updateSurveyAssetImageResponseLoading: false
            };

        case actionType.UPDATE_ASSET_IMAGE_COMMENT_REQUEST:
            return {
                ...state,
                updateAssetImageCommentResponseLoading: true
            };
        case actionType.UPDATE_ASSET_IMAGE_COMMENT_SUCCESS:
            return {
                ...state,
                updateAssetImageCommentResponse: { success: true, data: { ...action.response } },
                updateAssetImageCommentResponseLoading: false
            };
        case actionType.UPDATE_ASSET_IMAGE_COMMENT_FAILURE:
            return {
                ...state,
                updateAssetImageCommentResponse: { success: false, ...action.error },
                updateAssetImageCommentResponseLoading: false
            };

        case actionType.UPDATE_SURVEY_ASSETS_ENTITY_PARAMS_SUCCESS:
            return {
                ...state,
                surveyAssetEntityParams: { ...action.response }
            };
        case actionType.UPDATE_SURVEY_ASSETS_ENTITY_PARAMS_FAILURE:
            return {
                ...state,
                surveyAssetEntityParams: { ...action.error }
            };

        case actionType.UPDATE_INACCESSIBLE_SPACE_ENTITY_PARAMS_SUCCESS:
            return {
                ...state,
                inaccessibleSpaceEntityParams: { ...action.response }
            };
        case actionType.UPDATE_INACCESSIBLE_SPACE_ENTITY_PARAMS_FAILURE:
            return {
                ...state,
                inaccessibleSpaceEntityParams: { ...action.error }
            };

        case actionType.GET_ASSET_SURVEY_PROJECTS_EXPORT_REQUEST:
            return {
                ...state,
                getAssetSurveyProjectExportResponseLoading: true
            };
        case actionType.GET_ASSET_SURVEY_PROJECTS_EXPORT_SUCCESS:
            return {
                ...state,
                getAssetSurveyProjectExportResponse: { success: true, data: { ...action.response } },
                getAssetSurveyProjectExportResponseLoading: false
            };
        case actionType.GET_ASSET_SURVEY_PROJECTS_EXPORT_FAILURE:
            return {
                ...state,
                getAssetSurveyProjectExportResponse: { success: false, ...action.error },
                getAssetSurveyProjectExportResponseLoading: false
            };

        case actionType.GET_SURVEY_ASSET_EXPORT_REQUEST:
            return {
                ...state,
                getSurveyAssetsExportResponseLoading: true
            };
        case actionType.GET_SURVEY_ASSET_EXPORT_SUCCESS:
            return {
                ...state,
                getSurveyAssetsExportResponse: { success: true, data: { ...action.response } },
                getSurveyAssetsExportResponseLoading: false
            };
        case actionType.GET_SURVEY_ASSET_EXPORT_FAILURE:
            return {
                ...state,
                getSurveyAssetsExportResponse: { success: false, ...action.error },
                getSurveyAssetsExportResponseLoading: false
            };

        case actionType.GET_SURVEY_ASSET_COMMON_DATA_BY_IDS_REQUEST:
            return {
                ...state,
                getSurveyAssetsCommonDataLoading: true
            };
        case actionType.GET_SURVEY_ASSET_COMMON_DATA_BY_IDS_SUCCESS:
            return {
                ...state,
                getSurveyAssetsCommonData: { success: true, data: { ...action.response } },
                getSurveyAssetsCommonDataLoading: false
            };
        case actionType.GET_SURVEY_ASSET_COMMON_DATA_BY_IDS_FAILURE:
            return {
                ...state,
                getSurveyAssetsCommonData: { success: false, ...action.error },
                getSurveyAssetsCommonDataLoading: false
            };

        case actionType.UPDATE_MULTI_SURVEY_ASSET_REQUEST:
            return {
                ...state,
                updateMultiSurveyAssetLoading: true
            };
        case actionType.UPDATE_MULTI_SURVEY_ASSET_SUCCESS:
            return {
                ...state,
                updateMultiSurveyAsset: { success: true, data: { ...action.response } },
                updateMultiSurveyAssetLoading: false
            };
        case actionType.UPDATE_MULTI_SURVEY_ASSET_FAILURE:
            return {
                ...state,
                updateMultiSurveyAsset: { success: false, ...action.error },
                updateMultiSurveyAssetLoading: false
            };

        case actionType.RESET_MULTI_COMMON_DATA_SUCCESS:
            return {
                ...state,
                getSurveyAssetsCommonData: null
            };

        case actionType.RESET_MULTI_COMMON_DATA_FAILURE:
            return {
                ...state,
                getSurveyAssetsCommonData: null
            };

        case actionType.GET_ALL_SURVEY_ASSET_IDS_REQUEST:
            return {
                ...state,
                getAllSurveyAssetIdsResponseLoading: true
            };
        case actionType.GET_ALL_SURVEY_ASSET_IDS_SUCCESS:
            return {
                ...state,
                getAllSurveyAssetIdsResponse: { success: true, data: { ...action.response } },
                getAllSurveyAssetIdsResponseLoading: false
            };
        case actionType.GET_ALL_SURVEY_ASSET_IDS_FAILURE:
            return {
                ...state,
                getAllSurveyAssetIdsResponse: { success: false, ...action.error },
                getAllSurveyAssetIdsResponseLoading: false
            };

        case actionType.RUN_WELLS_FARGO_SCRIPT_REQUEST:
            return {
                ...state,
                runWellsFargoResponseLoading: true
            };
        case actionType.RUN_WELLS_FARGO_SCRIPT_SUCCESS:
            return {
                ...state,
                runWellsFargoResponse: { success: true, data: { ...action.response } },
                runWellsFargoResponseLoading: false
            };
        case actionType.RUN_WELLS_FARGO_SCRIPT_FAILURE:
            return {
                ...state,
                runWellsFargoResponse: { success: false, ...action.error },
                runWellsFargoResponseLoading: false
            };

        case actionType.GET_SURVEYOR_DROPDOWN_REQUEST:
            return {
                ...state,
                getSurveyorDropdownResponseLoading: true
            };
        case actionType.GET_SURVEYOR_DROPDOWN_SUCCESS:
            return {
                ...state,
                getSurveyorDropdownResponse: { success: true, data: { ...action.response } },
                getSurveyorDropdownResponseLoading: false
            };
        case actionType.GET_SURVEYOR_DROPDOWN_FAILURE:
            return {
                ...state,
                getSurveyorDropdownResponse: { success: false, ...action.error },
                getSurveyorDropdownResponseLoading: false
            };

        case actionType.GET_ASSET_VOICE_NOTES_REQUEST:
            return {
                ...state,
                getAssetVoiceNotesResponseLoading: true
            };
        case actionType.GET_ASSET_VOICE_NOTES_SUCCESS:
            return {
                ...state,
                getAssetVoiceNotesResponse: { success: true, data: { ...action.response } },
                getAssetVoiceNotesResponseLoading: false
            };
        case actionType.GET_ASSET_VOICE_NOTES_FAILURE:
            return {
                ...state,
                getAssetVoiceNotesResponse: { success: false, ...action.error },
                getAssetVoiceNotesResponseLoading: false
            };

        case actionType.DELETE_ASSET_BY_ID_VOICE_NOTES_REQUEST:
            return {
                ...state,
                deleteAssetByIdVoiceNotesLoading: true
            };
        case actionType.DELETE_ASSET_BY_ID_VOICE_NOTES_SUCCESS:
            return {
                ...state,
                deleteAssetByIdVoiceNotesResponse: { success: true, data: { ...action.response } },
                deleteAssetByIdVoiceNotesLoading: false
            };
        case actionType.DELETE_ASSET_BY_ID_VOICE_NOTES_FAILURE:
            return {
                ...state,
                deleteAssetByIdVoiceNotesResponse: { success: false, ...action.error },
                deleteAssetByIdVoiceNotesLoading: false
            };
        case actionType.GET_ASSET_SURVEY_FILTER_REQUEST:
            return {
                ...state,
                masterFilterList: {
                    ...state.masterFilterList,
                    [action.key]: { loading: true }
                }
            };
        case actionType.GET_ASSET_SURVEY_FILTER_SUCCESS:
            return {
                ...state,
                masterFilterList: {
                    ...state.masterFilterList,
                    [action.key]: { list: [...action.response?.list], count: action.response?.count, loading: false }
                }
            };
        case actionType.GET_ASSET_SURVEY_FILTER_FAILURE:
            return {
                ...state,
                masterFilterList: {
                    ...state.masterFilterList,
                    [action.key]: { loading: false }
                }
            };
        case actionType.SET_APPLIED_FILTER_NAMES:
            return {
                ...state,
                appliedFilterNames: {
                    ...state.appliedFilterNames,
                    [action.paramKey]: { ...(state.appliedFilterNames?.[action.paramKey] ?? {}), ...(action.names ?? {}) }
                }
            };
        case actionType.GET_ASSET_SURVEY_PROJECT_FILTER_REQUEST:
            return {
                ...state,
                assetSurveyProjectMasterFilterList: {
                    ...state.assetSurveyProjectMasterFilterList,
                    [action.key]: { loading: true }
                }
            };
        case actionType.GET_ASSET_SURVEY_PROJECT_FILTER_SUCCESS:
            return {
                ...state,
                assetSurveyProjectMasterFilterList: {
                    ...state.assetSurveyProjectMasterFilterList,
                    [action.key]: { list: [...action.response], loading: false }
                }
            };
        case actionType.GET_ASSET_SURVEY_PROJECT_FILTER_FAILURE:
            return {
                ...state,
                assetSurveyProjectMasterFilterList: {
                    ...state.assetSurveyProjectMasterFilterList,
                    [action.key]: { loading: false }
                }
            };

        case actionType.SET_CURRENT_AUDIO:
            return { ...state, currentAudio: action.payload };
        case actionType.STOP_CURRENT_AUDIO:
            if (state.currentAudio) {
                state.currentAudio.stop();
            }
            return { ...state, currentAudio: null };
        case actionType.SET_LOADING_STATE:
            return { ...state, isGlobalLoading: action.payload };

        case actionType.GET_ASSET_SURVEY_UNIFORMAT_REQUEST:
            return {
                ...state,
                uniformatList: {
                    ...state.uniformatList,
                    loading: true
                }
            };
        case actionType.GET_ASSET_SURVEY_UNIFORMAT_SUCCESS:
            return {
                ...state,
                uniformatList: {
                    ...action.response,
                    loading: false
                }
            };
        case actionType.GET_ASSET_SURVEY_UNIFORMAT_FAILURE:
            return {
                ...state,
                uniformatList: {
                    ...state.uniformatList,
                    loading: false
                }
            };

        case actionType.GET_DYNAMIC_DROPDOWN_DATA_REQUEST:
            return {
                ...state,
                getDynamicDropdownDataResponseLoading: { ...state.getDynamicDropdownDataResponseLoading, [action.entity]: true }
            };
        case actionType.GET_DYNAMIC_DROPDOWN_DATA_SUCCESS:
            return {
                ...state,
                getDynamicDropdownDataResponse: { ...state.getDynamicDropdownDataResponse, [action.entity]: action.response },
                getDynamicDropdownDataResponseLoading: { ...state.getDynamicDropdownDataResponseLoading, [action.entity]: false }
            };
        case actionType.GET_DYNAMIC_DROPDOWN_DATA_FAILURE:
            return {
                ...state,
                getDynamicDropdownDataResponseLoading: { ...state.getDynamicDropdownDataResponseLoading, [action.entity]: false }
            };

        case actionType.GET_SUGGESTION_DROPDOWN_BY_CLIENT_REQUEST:
            return {
                ...state,
                getSuggestionDropdownLoading: true
            };
        case actionType.GET_SUGGESTION_DROPDOWN_BY_CLIENT_SUCCESS:
            return {
                ...state,
                getSuggestionDropdown: action.response,
                getSuggestionDropdownLoading: false
            };
        case actionType.GET_SUGGESTION_DROPDOWN_BY_CLIENT_FAILURE:
            return {
                ...state,
                getSuggestionDropdownLoading: false
            };

        case actionType.RESET_DYNAMIC_DROPDOWN_DATA_SUCCESS:
            return {
                ...state,
                getDynamicDropdownDataResponseLoading: {},
                getDynamicDropdownDataResponse: {}
            };

        case actionType.RESET_DYNAMIC_DROPDOWN_DATA_FAILURE:
            return {
                ...state,
                getDynamicDropdownDataResponseLoading: {},
                getDynamicDropdownDataResponse: {}
            };

        case actionType.RESET_TABLE_DATA_SUCCESS:
            return {
                ...state,
                surveyAssetList: { surveyAssetLoading: false },
                getGroupEditProgressResponse: { loading: false },
                updateMultiSurveyAsset: null
            };

        case actionType.RESET_TABLE_DATA_FAILURE:
            return {
                ...state,
                surveyAssetList: { surveyAssetLoading: false }
            };

        case actionType.UPDATE_DEFAULT_IMAGE_REQUEST:
            return {
                ...state,
                defaultImageLoading: true
            };
        case actionType.UPDATE_DEFAULT_IMAGE_SUCCESS:
            return {
                ...state,
                defaultImageResponse: action.response,
                defaultImageLoading: false
            };
        case actionType.UPDATE_DEFAULT_IMAGE_FAILURE:
            return {
                ...state,
                defaultImageLoading: false
            };

        case actionType.SEARCH_AND_REPLACE_REQUEST:
            return {
                ...state,
                searchAndReplaceAssetLoading: true
            };
        case actionType.SEARCH_AND_REPLACE_SUCCESS:
            return {
                ...state,
                searchAndReplaceAssetResponse: action.response,
                searchAndReplaceAssetLoading: false
            };
        case actionType.SEARCH_AND_REPLACE_FAILURE:
            return {
                ...state,
                searchAndReplaceAssetLoading: false
            };

        case actionType.FIND_BEFORE_REPLACE_REQUEST:
            return {
                ...state,
                findAssetBeforeReplacingAssetLoading: true
            };
        case actionType.FIND_BEFORE_REPLACE_SUCCESS:
            return {
                ...state,
                findAssetBeforeReplacingAssetResponse: action.response,
                findAssetBeforeReplacingAssetLoading: false
            };
        case actionType.FIND_BEFORE_REPLACE_FAILURE:
            return {
                ...state,
                findAssetBeforeReplacingAssetLoading: false
            };

        case actionType.DELETE_ASSET_IMAGE_REQUEST:
            return {
                ...state,
                deleteImageLoading: true
            };
        case actionType.DELETE_ASSET_IMAGE_SUCCESS:
            return {
                ...state,
                deleteImageResponse: action.response,
                deleteImageLoading: false
            };
        case actionType.DELETE_ASSET_IMAGE_FAILURE:
            return {
                ...state,
                deleteImageResponse: action.error,
                deleteImageLoading: false
            };

        case actionType.GET_TABLE_SUMMARY_DATA_REQUEST:
            return {
                ...state,
                getTableSummaryDataLoading: true
            };
        case actionType.GET_TABLE_SUMMARY_DATA_SUCCESS:
            return {
                ...state,
                getTableSummaryDataResponse: action.response,
                getTableSummaryDataLoading: false
            };
        case actionType.GET_TABLE_SUMMARY_DATA_FAILURE:
            return {
                ...state,
                getTableSummaryDataResponse: action.error,
                getTableSummaryDataLoading: false
            };
        case actionType.RESET_IMAGE_REDUCER:
            return {
                ...state,
                getSurveyAssetImagesById: null,
                getStandardImagesById: null
            };
        case actionType.UPDATE_CLIENT_STANDARD_ENTITY_PARAMS_SUCCESS: {
            const entityParamsKey = getStandardEntityParamsStateKey(action?.entityType);
            return {
                ...state,
                [entityParamsKey]: { ...action.response }
            };
        }
        case actionType.UPDATE_CLIENT_STANDARD_ENTITY_PARAMS_FAILURE: {
            const entityParamsKey = getStandardEntityParamsStateKey(action?.entityType);
            return {
                ...state,
                [entityParamsKey]: { ...action.error }
            };
        }

        case actionType.GET_CLIENT_STANDARD_REQUEST:
            return {
                ...state,
                clientStandardList: { loading: true }
            };
        case actionType.GET_CLIENT_STANDARD_SUCCESS:
            return {
                ...state,
                clientStandardList: { loading: false, success: true, ...action.response }
            };
        case actionType.GET_CLIENT_STANDARD_FAILURE:
            return {
                ...state,
                clientStandardList: { loading: false, success: false, ...action.error }
            };
        case actionType.GET_SYNCED_DATA_REQUEST:
            return {
                ...state,
                standardSyncedData: { loading: true }
            };
        case actionType.GET_SYNCED_DATA_SUCCESS:
            return {
                ...state,
                standardSyncedData: { loading: false, success: true, ...action.response }
            };
        case actionType.GET_SYNCED_DATA_FAILURE:
            return {
                ...state,
                standardSyncedData: { loading: false, success: false, ...action.error }
            };
        case actionType.UPDATE_SURVEY_CLIENT_DELIVERABLE_REQUEST:
            return {
                ...state,
                updateClientDeliverable: null,
                updateClientDeliverableLoading: true
            };
        case actionType.UPDATE_SURVEY_CLIENT_DELIVERABLE_SUCCESS:
            return {
                ...state,
                updateClientDeliverable: { success: true, ...action.response },
                updateClientDeliverableLoading: false
            };
        case actionType.UPDATE_SURVEY_CLIENT_DELIVERABLE_FAILURE:
            return {
                ...state,
                updateClientDeliverable: { success: false, ...action.error },
                updateClientDeliverableLoading: false
            };

        case actionType.GET_CLIENT_DELIVERABLE_REQUEST:
            return {
                ...state,
                clientDeliverableList: { loading: true }
            };
        case actionType.GET_CLIENT_DELIVERABLE_SUCCESS:
            return {
                ...state,
                clientDeliverableList: { loading: false, success: true, ...action.response }
            };
        case actionType.GET_CLIENT_DELIVERABLE_FAILURE:
            return {
                ...state,
                clientDeliverableList: { loading: false, success: false, ...action.error }
            };
        case actionType.UPDATE_CLIENT_DELIVERABLE_ENTITY_PARAMS_SUCCESS:
            return {
                ...state,
                clientDeliverableEntityParams: { ...action.response }
            };
        case actionType.UPDATE_CLIENT_DELIVERABLE_ENTITY_PARAMS_FAILURE:
            return {
                ...state,
                clientDeliverableEntityParams: { ...action.error }
            };
        case actionType.GET_UNIFORMAT_LEVEL_REQUEST:
            return {
                ...state,
                uniformatLevelList: { loading: true }
            };
        case actionType.GET_UNIFORMAT_LEVEL_SUCCESS:
            return {
                ...state,
                uniformatLevelList: { loading: false, success: true, ...action.response }
            };
        case actionType.GET_UNIFORMAT_LEVEL_FAILURE:
            return {
                ...state,
                uniformatLevelList: { loading: false, success: false, ...action.error }
            };

        case actionType.GET_DROPDOWN_LIST_REQUEST:
            return {
                ...state
            };
        case actionType.GET_DROPDOWN_LIST_SUCCESS:
            return {
                ...state,
                dropdownFilterList: { success: true, list: action.response || [] }
            };
        case actionType.GET_DROPDOWN_LIST_FAILURE:
            return {
                ...state,
                dropdownFilterList: { success: false, ...action.error }
            };
        case actionType.UPDATE_SURVEY_STANDARD_REQUEST:
            return {
                ...state,
                updateStandardData: { loading: true }
            };
        case actionType.UPDATE_SURVEY_STANDARD_SUCCESS:
            return {
                ...state,
                updateStandardData: { loading: false, success: true, ...action.response }
            };
        case actionType.UPDATE_SURVEY_STANDARD_FAILURE:
            return {
                ...state,
                updateStandardData: { loading: false, success: false, ...action.error }
            };

        case actionType.GET_SURVEY_STANDARD_BY_ID_REQUEST:
            return {
                ...state,
                getStandardById: { loading: true }
            };
        case actionType.GET_SURVEY_STANDARD_BY_ID_SUCCESS:
            return {
                ...state,
                getStandardById: { loading: false, success: true, data: { ...action.response }, id: action?.id }
            };
        case actionType.GET_SURVEY_STANDARD_BY_ID_FAILURE:
            return {
                ...state,
                getStandardById: { loading: false, success: false, ...action.error }
            };
        case actionType.GET_CLIENT_DELIVERABLE_FILTER_REQUEST:
            return {
                ...state
            };
        case actionType.GET_CLIENT_DELIVERABLE_FILTER_SUCCESS:
            return {
                ...state,
                clientDeliverableFilterList: { success: true, list: action.response || [] }
            };
        case actionType.GET_CLIENT_DELIVERABLE_FILTER_FAILURE:
            return {
                ...state,
                clientDeliverableFilterList: { success: false, ...action.error }
            };
        case actionType.GET_STANDARD_IMAGES_BY_ID_REQUEST:
            return {
                ...state
            };
        case actionType.GET_STANDARD_IMAGES_BY_ID_SUCCESS:
            return {
                ...state,
                getStandardImagesById: { success: true, data: { ...action.response } }
            };
        case actionType.GET_STANDARD_IMAGES_BY_ID_FAILURE:
            return {
                ...state,
                getStandardImagesById: { success: false, ...action.error }
            };
        case actionType.GET_AI_ANALYSE_DATA_REQUEST:
            return {
                ...state,
                getAiAnalyseResponse: { loading: true }
            };
        case actionType.GET_AI_ANALYSE_DATA_SUCCESS:
            return {
                ...state,
                getAiAnalyseResponse: { loading: false, ...action.response }
            };
        case actionType.GET_AI_ANALYSE_DATA_FAILURE:
            return {
                ...state,
                getAiAnalyseResponse: { loading: false, ...action.error }
            };
        case actionType.POST_AI_ANALYSE_DATA_REQUEST:
            return {
                ...state,
                postAiAnalyseResponse: { loading: true }
            };
        case actionType.POST_AI_ANALYSE_DATA_SUCCESS:
            return {
                ...state,
                postAiAnalyseResponse: { loading: false, ...action.response }
            };
        case actionType.POST_AI_ANALYSE_DATA_FAILURE:
            return {
                ...state,
                postAiAnalyseResponse: { loading: false, ...action.error }
            };
        case actionType.RESET_AI_REDUCER:
            return {
                ...state,
                getAiAnalyseResponse: { loading: false },
                postAiAnalyseResponse: { loading: false },
                clearAiAnalyseResponse: { loading: false },
                patchAiAnalyseResponse: { loading: false }
            };
        case actionType.CLEAR_AI_ANALYSE_DATA_REQUEST:
            return {
                ...state,
                clearAiAnalyseResponse: { loading: true }
            };
        case actionType.CLEAR_AI_ANALYSE_DATA_SUCCESS:
            return {
                ...state,
                clearAiAnalyseResponse: { loading: false, ...action.response }
            };
        case actionType.CLEAR_AI_ANALYSE_DATA_FAILURE:
            return {
                ...state,
                clearAiAnalyseResponse: { loading: false, ...action.error }
            };
        case actionType.PATCH_AI_ANALYSE_DATA_REQUEST:
            return {
                ...state,
                patchAiAnalyseResponse: { loading: true }
            };
        case actionType.PATCH_AI_ANALYSE_DATA_SUCCESS:
            return {
                ...state,
                patchAiAnalyseResponse: { loading: false, ...action.response }
            };
        case actionType.PATCH_AI_ANALYSE_DATA_FAILURE:
            return {
                ...state,
                patchAiAnalyseResponse: { loading: false, ...action.error }
            };
        case actionType.RESET_PATCH_AI_ANALYSIS:
            return { ...state, patchAiAnalyseResponse: { loading: false } };
        case actionType.ASSET_TABLE_AI_ANALYSIS:
            return { ...state, assetTableAiAnalysisClick: action?.entity };

        case actionType.GET_SELECT_ALL_LIST_REQUEST:
            return {
                ...state,
                getselectAllStandardList: { loading: true }
            };
        case actionType.GET_SELECT_ALL_LIST_SUCCESS:
            return {
                ...state,
                getselectAllStandardList: { loading: false, ...action.response }
            };
        case actionType.GET_SELECT_ALL_LIST_FAILURE:
            return {
                ...state,
                getselectAllStandardList: { loading: false, ...action.error }
            };
        case actionType.GET_STANDARD_TABLE_EXPORT_REQUEST:
            return {
                ...state,
                getStandardExportResponse: { loading: true }
            };
        case actionType.GET_STANDARD_TABLE_EXPORT_SUCCESS:
            return {
                ...state,
                getStandardExportResponse: { loading: false, success: true, data: { ...action.response } }
            };
        case actionType.GET_STANDARD_TABLE_EXPORT_FAILURE:
            return {
                ...state,
                getStandardExportResponse: { loading: false, success: false, ...action.error }
            };

        case actionType.GET_UNIFORMAT_TABLE_EXPORT_REQUEST:
            return {
                ...state,
                getUniformatExportResponse: { loading: true }
            };
        case actionType.GET_UNIFORMAT_TABLE_EXPORT_SUCCESS:
            return {
                ...state,
                getUniformatExportResponse: { loading: false, success: true, data: { ...action.response } }
            };
        case actionType.GET_UNIFORMAT_TABLE_EXPORT_FAILURE:
            return {
                ...state,
                getUniformatExportResponse: { loading: false, success: false, ...action.error }
            };

        case actionType.GET_LIST_FOR_SURVEYOR_REQUEST:
            return {
                ...state,
                getListForSurveyor: { loading: true }
            };
        case actionType.GET_LIST_FOR_SURVEYOR_SUCCESS:
            return {
                ...state,
                getListForSurveyor: { loading: false, ...action.response }
            };
        case actionType.GET_LIST_FOR_SURVEYOR_FAILURE:
            return {
                ...state,
                getListForSurveyor: { loading: false, ...action.error }
            };

        case actionType.GROUP_SURVEY_UPDATE_REQUEST:
            return {
                ...state,
                getGroupUpdateRespose: { loading: true }
            };
        case actionType.GROUP_SURVEY_UPDATE_SUCCESS:
            return {
                ...state,
                getGroupUpdateRespose: { loading: false, ...action.response }
            };
        case actionType.GROUP_SURVEY_UPDATE_FAILURE:
            return {
                ...state,
                getGroupUpdateRespose: { loading: false, ...action.error }
            };
        case actionType.PATCH_AI_ANALYZE_ASSET_DATA_REQUEST:
            return {
                ...state,
                patchAiAnalyseAssetResponse: { loading: true }
            };
        case actionType.PATCH_AI_ANALYZE_ASSET_DATA_SUCCESS:
            return {
                ...state,
                patchAiAnalyseAssetResponse: { loading: false, ...action.response }
            };
        case actionType.PATCH_AI_ANALYZE_ASSET_DATA_FAILURE:
            return {
                ...state,
                patchAiAnalyseAssetResponse: { loading: false, ...action.error }
            };
        case actionType.GET_ASSET_AI_ANALYSE_KEY_REQUEST:
            return {
                ...state,
                getAiAnalyseKeys: { loading: true }
            };
        case actionType.GET_ASSET_AI_ANALYSE_KEY_SUCCESS:
            return {
                ...state,
                getAiAnalyseKeys: {
                    loading: false,
                    ...action.response
                }
            };
        case actionType.GET_ASSET_AI_ANALYSE_KEY_FAILURE:
            return {
                ...state,
                getAiAnalyseKeys: {
                    loading: false,
                    ...action.error
                }
            };

        case actionType.GET_ENTITY_DROPDOWN_REQUEST:
            return {
                ...state,
                getEntityDropdownResponse: { loading: true }
            };
        case actionType.GET_ENTITY_DROPDOWN_SUCCESS:
            return {
                ...state,
                getEntityDropdownResponse: {
                    loading: false,
                    ...action.response
                }
            };
        case actionType.GET_ENTITY_DROPDOWN_FAILURE:
            return {
                ...state,
                getEntityDropdownResponse: {
                    loading: false,
                    ...action.error
                }
            };

        case actionType.GET_ASSET_GROUP_EDIT_PROGRESS_REQUEST:
            return {
                ...state,
                getGroupEditProgressResponse: { ...state.getGroupEditProgressResponse, loading: true }
            };
        case actionType.GET_ASSET_GROUP_EDIT_PROGRESS_SUCCESS:
            return {
                ...state,
                getGroupEditProgressResponse: {
                    loading: false,
                    ...action.response
                }
            };
        case actionType.GET_ASSET_GROUP_EDIT_PROGRESS_FAILURE:
            return {
                ...state,
                getGroupEditProgressResponse: {
                    loading: false,
                    ...action.error
                }
            };
        case actionType.RESET_GET_REDUCER:
            return {
                ...state,
                getSurveyorDataResponse: { loading: false }
            };
        case actionType.REVERT_MOBILE_ASSET_BY_ID_REQUEST:
            return {
                ...state,
                revertMobileAssetByIdResponse: { loading: true }
            };
        case actionType.REVERT_MOBILE_ASSET_BY_ID_SUCCESS:
            return {
                ...state,
                revertMobileAssetByIdResponse: { loading: false, success: true, ...action.response }
            };
        case actionType.REVERT_MOBILE_ASSET_BY_ID_FAILURE:
            return {
                ...state,
                revertMobileAssetByIdResponse: { loading: false, success: false, ...action.error }
            };
        case actionType.RESET_DATA_LOG:
            return {
                ...state,
                getDataLogsResponse: { loading: false }
            };
        case actionType.RESET_TABLE_DATA_SUCCESS:
            return {
                ...state,
                assetSurveyProjectsList: { loading: false }
            };

        case actionType.RESET_TABLE_DATA_FAILURE:
            return {
                ...state,
                assetSurveyProjectsList: { loading: false }
            };

        default:
            return state;
    }
};

export default reducers;
